import React from 'react';

import { UserTypes } from '@barboxx/types';
import type { Authentication } from '@barboxx/models/types';

export interface PersistedData {
    rememberMe?: boolean;
    email?: string;
}

export interface AuthContextProps<
    T extends Authentication.AuthReturn = Authentication.AuthReturn,
> {
    login: (
        data: Authentication.LoginRequest,
        allowedUserTypes?: UserTypes[]
    ) => Promise<T>;
    logout: () => Promise<void>;
    refreshExpiredToken: () => Promise<T>;
    auth: T;
    initializing: boolean;
    persist: PersistedData;
}

export function createAuthContext<
    T extends Authentication.AuthReturn = Authentication.AuthReturn,
>() {
    return React.createContext<AuthContextProps<T>>({} as AuthContextProps<T>);
}
